module.exports = __webpack_public_path__ + "assets/media/3.1440b171.wav";